import { useUserContext } from '#app/app/AppStateStore'
import { PagePaths } from '#app/shared/navigation/pagePaths'
import { useAuth0 } from '@auth0/auth0-react'
import { useEffect, useState } from 'react'

export const useSignOut = ({
  returnToHome = false
}: { returnToHome?: boolean } = {}) => {
  const { logout } = useAuth0()
  const userService = useUserContext()
  const [isSigningOut, setIsSigningOut] = useState(false)

  useEffect(() => {
    if (!isSigningOut) {
      return
    }

    // Preserve current location for return after re-authentication
    const returnToRoot = `${window.location.origin}${PagePaths.Home}`
    const currentPath = window.location.pathname
    const returnTo = returnToHome
      ? returnToRoot
      : `${returnToRoot}?returnTo=${currentPath}`

    userService.send({
      type: 'Signout',
      auth0Logout: logout,
      returnTo: returnTo
    })
  }, [isSigningOut, logout, userService, returnToHome])

  const performSignOut = () => {
    setIsSigningOut(true)
  }

  return { isSigningOut, performSignOut }
}
